/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { ApiStatus } from '@ibm-watson/shared/ts';
import { validateSegmentKey } from './actions';

export const initialState = {
  validateStatus: ApiStatus.IDLE,
  error: null,
  valid: null,
  value: null
};

export const reducers = {};

export const extraReducers = builder => {
  builder
    .addCase(validateSegmentKey.pending, (state, _action) => {
      state.segment.validateStatus = ApiStatus.LOADING;
      state.segment.error = null;
    })
    .addCase(validateSegmentKey.fulfilled, (state, action) => {
      state.segment.validateStatus = ApiStatus.SUCCEEDED;
      state.segment.error = null;
      state.segment.valid = action.payload.valid;
      state.segment.value = action.payload.key;
    })
    .addCase(validateSegmentKey.rejected, (state, action) => {
      state.segment.validateStatus = ApiStatus.ERROR;
      state.segment.error = action.error;

      state.segment.valid = false;
      state.segment.value = null;
    });
};
